import { api } from "../utils/axios";

export const submitSuggestion = async (
  restaurantId: string,
  body: {
    
  }
) => {
  try {
    const response = await api.post(
      `/api/suggestions/${restaurantId}`,
      body,
      { withCredentials: true }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to start claim. Please try again."
    );
  }
};